import React from 'react'
import RateCell from './RateCell'

import { DATA_RATE, SORT_PARAMETERS } from '../../const/sort'
import { rateColStyles } from '../../const/tableColumnsSize'

const RateCol = ({ classes, handleSortChange, currencySymbol }) => {
  return {
    header: 'Rate',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: rateColStyles,
    attributes: { 'data-copy': DATA_RATE },
    sortParameter: SORT_PARAMETERS.RATE,
    onSortingChange: handleSortChange,
    Cell: productValues => <RateCell productValues={productValues} currencySymbol={currencySymbol} />
  }
}

export default RateCol
